// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CopilotDashboard page styles */
.copilot-dashboard-root {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/CopilotDashboard.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":["/* CopilotDashboard page styles */\n.copilot-dashboard-root {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
